import { STEPS } from "./selectors/steps"
import { STEPPER_ACTIONS } from "components/stepper/constants"

const { SUBMIT, CANCEL } = STEPPER_ACTIONS

export function makeStepAnalytics(action, step, isEditMode) {
  const { id, submitButton, cancelButton } = STEPS(isEditMode)[step]
  let contextAction

  switch (action) {
    case SUBMIT:
      contextAction = submitButton.trackingId ?? "next"
      break
    case CANCEL:
      contextAction = cancelButton.trackingId ?? action
      break
    default:
      contextAction = action
      break
  }

  return {
    action: contextAction,
    step: id,
  }
}

export const BASKET_TYPES = ["LONG_ONLY", "SHORT_ONLY", "LONG_SHORT"]
